import { createAction, props } from '@ngrx/store';

export const setAccessToken = createAction(
  '[Auth] Set Access Token',
  props<{ accessToken: string }>()
);

export const clearAccessToken = createAction('[Auth] Clear Access Token');
